import { iDefaultAccountFactoryV3Abi } from "@gearbox-protocol/sdk/abi/iDefaultAccountFactoryV3";
import { iDSRegistryServiceAbi } from "@gearbox-protocol/sdk/abi/rwa/iDSRegistryService";
import { iDSTokenAbi } from "@gearbox-protocol/sdk/abi/rwa/iDSToken";
import {
  AbstractAdapterContract,
  BaseContract,
  iERC4626Abi,
  type OnchainSDK,
} from "@gearbox-protocol/sdk/onchain";
import { erc20Abi } from "viem";

/**
 * Adds some abis that are not loaded by sdk automatically as BaseContracts
 * @param sdk
 */
export default async function addExtraAbis(sdk: OnchainSDK) {
  for (const factory of sdk.rwa.factories) {
    for (const t of factory.dsTokens) {
      new BaseContract(sdk, {
        abi: iDSTokenAbi,
        addr: t.address,
        name: `Token: ${sdk.tokensMeta.mustGet(t.address).symbol}`,
      });
      const registryServiceId = await sdk.client.readContract({
        address: t.address,
        abi: iDSTokenAbi,
        functionName: "REGISTRY_SERVICE",
      });

      const registryService = await sdk.client.readContract({
        address: t.address,
        abi: iDSTokenAbi,
        functionName: "getDSService",
        args: [registryServiceId],
      });
      const rs = sdk.getContract(registryService);
      if (!rs) {
        console.log("Adding RegistryService", registryService);
        new BaseContract(sdk, {
          addr: registryService,
          abi: iDSRegistryServiceAbi,
          name: "RegistryService",
        });
      }
    }
  }

  // add all token
  for (const t of sdk.tokensMeta.values()) {
    const contract = sdk.getContract(t.addr);
    if (!contract) {
      if (sdk.tokensMeta.isRWAUnderlying(t)) {
        new BaseContract(sdk, {
          addr: t.addr,
          abi: iERC4626Abi,
          name: `Token: ${t.symbol}`,
        });
      } else {
        new BaseContract(sdk, {
          addr: t.addr,
          abi: erc20Abi,
          name: `Token: ${t.symbol}`,
        });
      }
    }
  }

  for (const cm of sdk.marketRegister.creditManagers) {
    const contract = sdk.getContract(cm.creditManager.accountFactory);
    if (!contract) {
      new BaseContract(sdk, {
        addr: cm.creditManager.accountFactory,
        abi: iDefaultAccountFactoryV3Abi,
        name: "CreditAccountFactory",
      });
    }

    for (const adapter of cm.creditManager.adapters.values()) {
      const contract = sdk.getContract(adapter.targetContract);
      if (
        !contract &&
        adapter instanceof AbstractAdapterContract &&
        Array.isArray(adapter.protocolAbi) &&
        adapter.protocolAbi.length > 0
      ) {
        new BaseContract(sdk, {
          addr: adapter.targetContract,
          abi: adapter.protocolAbi,
          name: `${adapter.name} target contract`,
        });
      }
    }
  }
}
